import { render, staticRenderFns } from "./productNameEditor.vue?vue&type=template&id=31606400&scoped=true&"
import script from "./productNameEditor.vue?vue&type=script&lang=js&"
export * from "./productNameEditor.vue?vue&type=script&lang=js&"
import style0 from "./productNameEditor.vue?vue&type=style&index=0&id=31606400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31606400",
  null
  
)

export default component.exports